<template>
  <div>
    <div
      ref="canvasParent"
      class="fabric-canvas-box"
      :style="`visibility:${enableDraw ? 'visible' : 'hidden'}`">
      <canvas ref="fabricCanvas" />
    </div>
    <div class="annotation-toolbar-box">
      <div class="fabric-tool-box">
        <div class="tool-box">
          <div
            :class="`item-box ${isActive(item) ? 'active' : ''}`"
            v-for="(item, index) in drawTypeList"
            :key="index"
            @click="handleDrawTypeClick(item.name, index)">
            <icon-svg
              :icon-class="item.icon"
              size="24" />
          </div>
        </div>
        <div class="split-line-box" />
        <div class="action-btn-box">
          <div
            class="item-box icon-box"
            @click="rollBack"
            title="撤销绘制">
            <icon-svg
              icon-class="icon-chexiaoshangyibu"
              size="24" />
          </div>
          <div class="item-box">
            <el-button
              size="small"
              @click="handleCancel"
              >取消</el-button
            >
          </div>
          <div class="item-box">
            <el-button
              type="primary"
              size="small"
              class="primary-btn primary-ang-btn"
              @click="handleSubmit">
              确认
            </el-button>
          </div>
        </div>
      </div>
      <div
        class="fabric-style-box"
        ref="fabricStyle"
        v-if="isFabricStyleVisible">
        <div
          class="style-item-box"
          v-if="currDrawType !== 'text'">
          <div class="label-box">线条粗细度：</div>
          <div class="slider-box">
            <el-slider
              class="slider-primary"
              input-size="mini"
              v-model="currLineWidth"
              :min="1"
              :max="20"
              :step="1"
              @change="handleLineWidthChange" />
          </div>
        </div>
        <div
          v-else
          class="style-item-box">
          <div class="label-box">字号：</div>
          <div class="slider-box">
            <el-slider
              class="slider-primary"
              input-size="mini"
              v-model="currFontSize"
              :min="14"
              :max="60"
              :step="1"
              @change="handleLineWidthChange" />
          </div>
        </div>
        <div class="style-item-box">
          <div class="label-box">颜色：</div>
          <div class="color-box">
            <div
              class="color-item-box"
              v-for="(item, index) in colorList"
              :key="index"
              :style="`background-color: ${item};`"
              @click="handleColorClick(item)">
              <div
                v-if="currColor === item"
                class="select-box">
                <icon-svg
                  icon-class="icon-baocunbianji"
                  size="8" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as fabric from 'fabric'
import FabricCanvasHelper from './FabricCanvasHelper'

export default {
  data() {
    return {
      // 是否处于视口添加模式
      isAddView: false,
      // isModifyView
      isModifyView: false,

      enableDraw: false,

      currDrawType: '',
      drawTypeList: [
        {
          name: 'pen',
          icon: 'icon-huabi'
        },
        {
          name: 'polyline',
          icon: 'icon-zhexian'
        },
        {
          name: 'arrow',
          icon: 'icon-jiantou'
        },
        {
          name: 'cloudline',
          icon: 'icon-yuanxinghuabian'
        },
        {
          name: 'star',
          icon: 'icon-xingxing'
        },
        {
          name: 'rectangle',
          icon: 'icon-juxing'
        },
        {
          name: 'ellipse',
          icon: 'icon-yuanxing'
        },
        {
          name: 'cross',
          icon: 'icon-Xxing'
        },
        {
          name: 'text',
          icon: 'icon-wenben'
        }
      ],

      isFabricStyleVisible: false,
      currLineWidth: 3,
      currFontSize: 25,
      currColor: '#FC0000',
      colorList: [
        '#FC0000',
        '#0015FC',
        '#FFDA07',
        '#6742FF',
        '#00FFEA',
        '#FF7442',
        '#66FF07',
        '#DCDCDC',
        '#212429',
        '#FFFFFF'
      ],

      isDrawing: false,
      drawingObject: null,
      mouseMoveCount: 0, // 用于减少绘制频率
      mouseFrom: null,
      mouseTo: null
    }
  },
  mounted() {
    this.initFabric()
    this.addEventListener()

    this.addEngineCanvasEventListener()
  },
  beforeDestroy() {
    this.removeEventListener()
    this.destroyFabricCanvasHelper()

    this.removeEngineCanvasEventListener()
  },
  methods: {
    initFabric() {
      this.fabricCanvasHelper = new FabricCanvasHelper()

      let canvasDom = this.$refs.fabricCanvas
      let width = this.$refs.canvasParent.clientWidth
      let height = this.$refs.canvasParent.clientHeight
      const canvas = new fabric.Canvas(canvasDom, { width, height })
      this.fabricCanvasHelper.initial(canvas)
    },
    addEventListener() {
      this.fabricCanvasHelper.fabricCanvas.on('mouse:down', this.onMouseDown)
      this.fabricCanvasHelper.fabricCanvas.on('mouse:move', this.onMouseMove)
      this.fabricCanvasHelper.fabricCanvas.on('mouse:up', this.onMouseUp)
      // prettier-ignore
      this.fabricCanvasHelper.fabricCanvas.on("mouse:out", this.onCanvasMouseLeave);
      // prettier-ignore
      this.fabricCanvasHelper.fabricCanvas.on("contextmenu", this.onContextmenu);
      window.addEventListener('resize', this.onResizeEvent)
      document.addEventListener('keydown', this.onKeydownEvent)
    },
    removeEventListener() {
      this.fabricCanvasHelper.fabricCanvas.off('mouse:down', this.onMouseDown)
      this.fabricCanvasHelper.fabricCanvas.off('mouse:move', this.onMouseMove)
      this.fabricCanvasHelper.fabricCanvas.off('mouse:up', this.onMouseUp)
      // prettier-ignore
      this.fabricCanvasHelper.fabricCanvas.off("mouse:out", this.onCanvasMouseLeave);
      // prettier-ignore
      this.fabricCanvasHelper.fabricCanvas.off("contextmenu", this.onContextmenu);
      window.removeEventListener('resize', this.onResizeEvent)
      document.removeEventListener('keydown', this.onKeydownEvent)
    },
    handleDrawTypeClick(drawType, index) {
      if (this.currDrawType === drawType) return

      this.currColor = this.colorList[0]
      this.currLineWidth = 3
      this.currFontSize = 25
      this.fabricCanvasHelper.color = this.currColor
      if (drawType === 'text') {
        this.fabricCanvasHelper.lineWidth = this.currFontSize
      } else {
        this.fabricCanvasHelper.lineWidth = this.currLineWidth
      }

      this.isFabricStyleVisible = true
      this.$nextTick(() => {
        let domRef = this.$refs.fabricStyle
        let marginLeft = index * 44
        domRef.style.marginLeft = marginLeft + 'px'
      })

      this.currDrawType = drawType
      this.fabricCanvasHelper.fabricCanvas.selection = false
      if (!this.enableDraw) {
        this.enableDraw = true
      }

      const engineCanvas = window.BlackHole3D.canvas
      const fabricImage = new fabric.FabricImage(engineCanvas)
      this.fabricCanvasHelper.fabricCanvas.backgroundImage = fabricImage
      this.fabricCanvasHelper.getFabricCanvas().renderAll()
      if (drawType === 'pen') {
        this.fabricCanvasHelper.startDrawing()
      } else if (drawType === 'polyline') {
        this.mouseTo = { x: 0, y: 0 }
        this.fabricCanvasHelper.setDrawingMode(false)
      } else {
        this.fabricCanvasHelper.setDrawingMode(false)
      }
    },
    handleLineWidthChange(value) {
      this.fabricCanvasHelper.lineWidth = value
      if (this.currDrawType === 'pen') {
        this.fabricCanvasHelper.startDrawing()
      }

      let currActiveObject = this.fabricCanvasHelper.getActiveObject()
      if (currActiveObject && currActiveObject.drawType === 'text') {
        currActiveObject.set('fontSize', value)
        this.fabricCanvasHelper.getFabricCanvas().renderAll()
        return
      }

      if (currActiveObject && currActiveObject.drawType === this.currDrawType) {
        currActiveObject.set('strokeWidth', value)
        this.fabricCanvasHelper.getFabricCanvas().renderAll()
      }
    },
    handleColorClick(color) {
      if (this.currColor === color) return

      this.currColor = color
      this.fabricCanvasHelper.color = color
      if (this.currDrawType === 'pen') {
        this.fabricCanvasHelper.startDrawing()
      }

      let currActiveObject = this.fabricCanvasHelper.getActiveObject()
      if (currActiveObject && currActiveObject.drawType === 'text') {
        this.fabricCanvasHelper.updateTextBoxColor(currActiveObject, color)
        currActiveObject.set('borderColor', color)
        this.fabricCanvasHelper.getFabricCanvas().renderAll()
        return
      }

      if (currActiveObject && currActiveObject.drawType === this.currDrawType) {
        if (currActiveObject.drawType === 'arrow') {
          currActiveObject.set('fill', color)
        }
        currActiveObject.set('stroke', color)
        this.fabricCanvasHelper.getFabricCanvas().renderAll()
      }
    },
    rollBack() {
      this.fabricCanvasHelper.rollback()

      if (this.currDrawType === 'polyline') {
        this.isDrawing = false
        this.drawingObject = null
        this.mouseMoveCount = 0
        this.mouseTo = { x: 0, y: 0 }
        this.fabricCanvasHelper.setDrawingMode(false)
      }
    },
    handleCancel() {
      if (this.isAddView) {
        this.fabricCanvasHelper.clearActiveInstances()
        this.fabricCanvasHelper.clear()

        let annotationInfo = { viewportList: [] }
        this.$emit('openAddAnnotationDialog', annotationInfo)
      } else {
        this.$emit('closeAnnotationToolBar')
      }
    },
    handleSubmit() {
      if (!this.fabricCanvasHelper.getAllObjects().length) {
        this.$message.warning('还没有添加批注，请先添加批注')
        return
      }

      this.hideEngineTool().then(() => {
        let annotationImg = this.fabricCanvasHelper
          .getFabricCanvas()
          .toDataURL()
        let visualAngle = this.getViewAngle()
        let annotationInfo = {
          viewportList: [{ base64Image: annotationImg, visualAngle }]
        }
        this.$emit('openAddAnnotationDialog', annotationInfo)

        const BlackHole3D = window.BlackHole3D
        BlackHole3D.Graphics.setGeoCoordVisible(true)
        BlackHole3D.Graphics.setViewCubeVisible(true)
        BlackHole3D.Graphics.setSysUIPanelVisible(true)
      })
    },
    async hideEngineTool() {
      const BlackHole3D = window.BlackHole3D
      BlackHole3D.Graphics.setGeoCoordVisible(false)
      BlackHole3D.Graphics.setViewCubeVisible(false)
      BlackHole3D.Graphics.setSysUIPanelVisible(false)

      await this.sleep(100)
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    destroyFabricCanvasHelper() {
      this.fabricCanvasHelper.clearActiveInstances()
      this.fabricCanvasHelper.dispose()
      this.fabricCanvasHelper = null
    },
    addViewport() {
      this.isFabricStyleVisible = false
      this.currDrawType = ''

      this.fabricCanvasHelper.clearActiveInstances()
      this.fabricCanvasHelper.clear()
      this.enableDraw = false

      this.isAddView = true
    },
    modifyViewport() {
      this.isModifyView = true
    },
    getViewAngle() {
      let camLocate = window.BlackHole3D.Camera.getCamLocate()
      let { camDir, camPos, camRotate } = camLocate
      camDir = camDir.map(el => Number(el.toFixed(6)))
      camPos = camPos.map(el => Number(el.toFixed(6)))
      camRotate = camRotate.map(el => Number(el.toFixed(6)))
      let visualAngleObj = { camDir, camPos, camRotate }
      let visualAngle = JSON.stringify(visualAngleObj)

      return visualAngle
    },
    onMouseDown(eventInfo) {
      if (!this.currDrawType) return

      // 鼠标按下时取消跟随提示
      this.isModifyView = false

      let mousePos = this.transform2MousePosition(eventInfo)
      this.mouseFrom = mousePos

      // 鼠标点击区域是否已存在图层
      const activeObjects = this.fabricCanvasHelper.getActiveObjects()
      this.isDrawing = !activeObjects.length
      if (this.currDrawType === 'text') {
        this.isDrawing = false
        this.fabricCanvasHelper.addTextBox(this.mouseFrom)
      } else if (this.currDrawType === 'polyline' && this.isDrawing) {
        if (this.drawingObject === undefined || this.drawingObject === null) {
          this.draw()
        } else {
          let points = this.drawingObject.points
          points.push({ x: mousePos.x, y: mousePos.y })
          this.fabricCanvasHelper.getFabricCanvas().renderAll()
        }
      }
    },
    onMouseMove(eventInfo) {
      if (!this.currDrawType) return

      let mousePos = this.transform2MousePosition(eventInfo)
      this.mouseTo = mousePos

      if (this.isModifyView) {
        let coorInfo = {
          visible: true,
          tipContent: '修改视口',
          clientX: mousePos.x,
          clientY: mousePos.y
        }
        this.$eventManage.fire('canvasMouseMove', { coorInfo })
      } else {
        let coorInfo = { visible: false }
        this.$eventManage.fire('canvasMouseMove', { coorInfo })
      }

      const point = mousePos
      if (this.currDrawType === 'polyline') {
        if (this.drawingObject) {
          const points = this.drawingObject.points
          points[points.length - 1] = new fabric.Point(point.x, point.y)
          this.drawingObject.set({ points })
          this.fabricCanvasHelper.getFabricCanvas().requestRenderAll()
        }
        return
      }

      this.mouseMoveCount = this.mouseMoveCount + 1
      // prettier-ignore
      if (!this.isDrawing || !this.currDrawType || this.mouseMoveCount % 2) return;

      this.draw()
    },
    onMouseUp(eventInfo) {
      if (!this.currDrawType) return
      if (this.currDrawType === 'polyline') return
      let currObject = eventInfo.currentTarget
      if (this.currDrawType === 'pen' && currObject) {
        currObject.drawType = 'pen'
      }

      this.isDrawing = false
      this.drawingObject = null
      this.mouseMoveCount = 0
    },
    onContextmenu(eventInfo) {
      if (this.currDrawType === 'polyline') {
        eventInfo.e.preventDefault()
        const points = this.drawingObject.points
        points.pop()
        if (points.length < 2) {
          this.fabricCanvasHelper.remove(this.drawingObject)
          this.isDrawing = false
          this.drawingObject = null
          this.mouseMoveCount = 0
          this.mouseTo = null
          return
        }

        this.fabricCanvasHelper.drawPolyline(points)
        this.fabricCanvasHelper.remove(this.drawingObject)
        this.mouseTo = null
      }

      this.isDrawing = false
      this.drawingObject = null
      this.mouseMoveCount = 0
    },
    addEngineCanvasEventListener() {
      let domRef = window.BlackHole3D.canvas
      domRef.addEventListener('mousemove', this.onCanvasMouseMove)
      domRef.addEventListener('mouseleave', this.onCanvasMouseLeave)
    },
    removeEngineCanvasEventListener() {
      let coorInfo = { visible: false }
      this.$eventManage.fire('canvasMouseMove', { coorInfo })

      let domRef = window.BlackHole3D.canvas
      domRef.removeEventListener('mousemove', this.onCanvasMouseMove)
      domRef.removeEventListener('mouseleave', this.onCanvasMouseLeave)
    },
    onCanvasMouseMove(event) {
      if (this.isFabricStyleVisible) {
        let coorInfo = { visible: false }
        this.$eventManage.fire('canvasMouseMove', { coorInfo })
        return
      }

      let coorInfo = {
        visible: true,
        tipContent: '添加新视口',
        clientX: event.offsetX,
        clientY: event.offsetY
      }
      this.$eventManage.fire('canvasMouseMove', { coorInfo })
    },
    onCanvasMouseLeave() {
      let coorInfo = { visible: false }
      this.$eventManage.fire('canvasMouseMove', { coorInfo })
    },
    onResizeEvent() {
      if (this.$refs.canvasParent) {
        let width = this.$refs.canvasParent.clientWidth
        let height = this.$refs.canvasParent.clientHeight

        this.fabricCanvasHelper.getFabricCanvas().setWidth(width)
        this.fabricCanvasHelper.getFabricCanvas().setHeight(height)
      }
    },
    onKeydownEvent(e) {
      if (e.keyCode === 46 || e.keyCode === 8) {
        this.fabricCanvasHelper.clearActiveInstances()
      } else if (e.keyCode === 90 && e.ctrlKey) {
        this.fabricCanvasHelper.rollback()
      }
    },
    draw() {
      if (!this.mouseFrom || !this.mouseTo) return

      if (this.drawingObject) {
        this.fabricCanvasHelper.remove(this.drawingObject)
        this.drawingObject = null
      }

      let object = null

      switch (this.currDrawType) {
        case 'polyline':
          object = this.fabricCanvasHelper.drawPolyline([
            this.mouseFrom,
            this.mouseFrom
          ])
          break
        case 'arrow':
          object = this.fabricCanvasHelper.drawArrow(
            this.mouseFrom,
            this.mouseTo
          )
          break
        case 'cloudline':
          object = this.fabricCanvasHelper.drawCloudLine(
            this.mouseFrom,
            this.mouseTo
          )
          break
        case 'star':
          object = this.fabricCanvasHelper.drawStar(
            this.mouseFrom,
            this.mouseTo
          )
          break
        case 'rectangle':
          object = this.fabricCanvasHelper.drawRectangle(
            this.mouseFrom,
            this.mouseTo
          )
          break
        case 'ellipse':
          object = this.fabricCanvasHelper.drawEllipse(
            this.mouseFrom,
            this.mouseTo
          )
          break
        case 'cross':
          object = this.fabricCanvasHelper.drawCross(
            this.mouseFrom,
            this.mouseTo
          )
          break
      }

      this.drawingObject = object
    },
    transform2MousePosition(eventInfo) {
      const pointer = eventInfo.pointer

      let obj = {
        x: pointer.x,
        y: pointer.y
      }
      return obj
    },
    isActive(drawType) {
      return this.currDrawType === drawType.name
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.fabric-canvas-box {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  visibility: hidden;
}

.annotation-toolbar-box {
  position: absolute;
  left: 50%;
  top: 20px;
  transform: translate(-50%, 0);
  display: flex;
  align-items: center;
  padding: 8px;
  background: var(--base-light-color25);
  box-shadow: var(--base-bg-dark-color31);
  border-radius: 8px;
  border: 1px solid var(--base-border-light-color11);
  z-index: 1;

  .fabric-tool-box {
    display: flex;
    align-items: center;

    .tool-box {
      display: flex;
      align-items: center;

      .item-box {
        margin-right: 12px;
        padding: 4px;
        color: var(--base-dark36-color);
        border-radius: 7px;
        cursor: pointer;

        &:hover {
          color: var(--base-primary-bgColor);
          background: var(--base-bg-light-color77);
        }

        &.active {
          color: var(--base-primary-bgColor);
          background: var(--base-bg-light-color77);
        }
      }
    }

    .split-line-box {
      width: 0px;
      height: 32px;
      border: 1px solid var(--base-border-dark-color14);
    }

    .action-btn-box {
      display: flex;
      align-items: center;

      .item-box {
        margin-left: 12px;
        cursor: pointer;

        .el-button {
          border-radius: 4px;
        }
      }

      .icon-box {
        color: var(--annotation-tool-color);
      }
    }
  }

  .fabric-style-box {
    position: absolute;
    top: 60px;
    left: 12px;
    width: 248px;
    padding: 8px;
    font-size: 12px;
    border-radius: 8px;
    background: var(--base-light-color25);
    box-shadow: var(--base-bg-dark-color31);
    border: 1px solid var(--base-border-light-color11);

    .style-item-box {
      display: flex;
      align-items: center;
      margin-bottom: 4px;

      .label-box {
        flex-shrink: 0;
        color: var(--annotation-tool-text-color);
      }

      .slider-box {
        flex-grow: 1;
      }

      .color-box {
        display: flex;
        align-items: center;

        .color-item-box {
          position: relative;
          width: 16px;
          height: 16px;
          margin-right: 4px;
          border-radius: 3px;
          cursor: pointer;

          &:last-child {
            margin-right: 0;
          }

          .select-box {
            position: absolute;
            bottom: 0px;
            right: 0px;
            background: var(--base-bg-light-color82);
            color: var(--base-light-color27);
            border-radius: 50% 0 0 0;
          }
        }
      }
    }
  }
}
</style>
